module.exports = __webpack_public_path__ + "files/nancy.e14a2865db307f050a67b1cda43b4af3.pdf";